import script from "./image-magnifier.vue?vue&type=script&setup=true&lang=js"
export * from "./image-magnifier.vue?vue&type=script&setup=true&lang=js"

import "./image-magnifier.vue?vue&type=style&index=0&id=64496fc8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64496fc8"]])

export default __exports__